import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import * as _ from 'lodash';
import AggressiveReadingIcon from 'common/images/AggressiveReadingIcon';
import { toastr } from 'react-redux-toastr';
import Accordion from 'common/components/molecules/Accordion';
import { ENDPOINT, getDeviceGCPLogsUrl, getFullEndPointUrl, getImpUrl } from 'common/constants';
import RBAC from 'common/rbac/RBAC';
import PerChannelSvg from 'common/images/PerChannelSvg';
import { isPetasenseAdmin, isPetasenseViewer, isPartnerAdmin } from 'common/rbac/util';
import { localTimeString } from 'common/helpers';
import { parseErrorMessage } from 'common/helpers/errors';
import { Grid, Segment } from 'semantic-ui-react';
import {
  ResourceItemLabel,
  ResourceInputField,
  ResourceSection,
  ResourceItem
} from 'common/components/atoms/ResourceDetails';
import Modal from '../../../../common/components/organisms/Modal';
import { history } from '../../../../common/helpers/history';
import { withTranslation } from 'react-i18next';
import { getSensorTypeDisplayName } from 'common/utils/sensorTypeDisplayName';
import { translateSensorSelectOptions } from '../../utils/sensorMeasurementDisplay';
import * as sensorsActions from '../../actions/sensors.actions';
import LoadingSvg from '../../../../common/images/LoadingSvg';
import FlexContainer from '../../../../common/components/atoms/FlexContainer';
import CrossSvg from '../../../../common/images/CrossSvg';
import H1_T from '../../../../common/typography/H1/H1';
import H4_T from '../../../../common/typography/H4/H4';
import Button_T from '../../../../common/components/atoms/Button';
import { BatteryIcon } from '../../../../common/images/BatteryIcon';
import { PoeIcon } from '../../../../common/images/PoeIcon';
import WiFiSvg from '../../../../common/images/WiFiSvg';
import TxPortSvg from '../../../../common/images/TXPortSvg';
import AssignSensorModal from '../AssignSensorModal';
import {
  AGGRESSIVE_INTERVAL_THRESHOLD,
  ErrorMessages
} from '../../constants/sensors.constants';
import { getEpochFromDateTime } from '../../utils/sensorUtils';
import { getWifiScheduleState, isWifiConfigChanged, isWifiScheduleInPast } from '../../utils/wifiSchedule';
import WifiSetting from '../WifiSettings';
import TxPorts from '../TxPorts';
import LastReportedModal from '../DeviceReportedInfoModal';
import PreferredAPSettings from '../PreferredAPSettings';
import DeviceParameterAnalysis from '../DeviceParameterAnalysis';
import SiteReassignSection from '../SiteReassignSection';
import {
  resolveSiteAccountId,
  resolveOrganisationId,
  hasTransmitterMachineAssociation,
  hasTransmitterAttachedSensors,
} from '../../utils/siteReassignUtils';


const Container = styled(FlexContainer).attrs({ direction: 'column' })`
  padding: 2em;
  min-height: Calc(100vh - var(--title-bar-offset, 0px) - 138px);
`;
const H1 = styled(H1_T)`
  padding: ${props => (props.padding ? `${props.padding};` : '0;')};
  margin-bottom: 3px;
  min-width: max-content;
  width: 100%;
  cursor: pointer;
`;
const H4 = styled(H4_T)`
  width: max-content;
  ${props =>
    props.hover &&
    `
    &:hover {
      color: ${props.theme.primaryColor};
      font-weight: 600;
      cursor: pointer;
    }
  `}
`;
const SvgContainer = styled.span`
  cursor: pointer;
  margin-left: auto;
`;
const BorderContainer = styled.div`
  border: 2px solid #f0f0f0;
  padding: 20px;
`;
const Button = styled(Button_T)`
  width: max-content;
  z-index: 2;
  padding-left: ${props => props.paddingLeft ? props.paddingLeft : '52px'};
  ${props => props.paddingBottom && `padding-bottom: ${props.paddingBottom};`}
  ${props => props.fontsize && `font-size: ${props.fontsize};`}
  ${props => props.marginLeft && `margin-left: ${props.marginLeft};`}
  ${props => props.marginRight && `margin-right: ${props.marginRight};`}
`;
const SaveButton = styled(Button_T)`
  max-width: 200px;
  ${props => props.fontsize && `font-size: ${props.fontsize};`}
  ${props => props.marginLeft && `margin-left: ${props.marginLeft};`}
  ${props => props.marginRight && `margin-right: ${props.marginRight};`}
`;
const AnalysisButton = styled(Button_T)`
 width: max-content;
 ${props => props.fontsize && `font-size: ${props.fontsize};`}
 ${props => props.marginLeft && `margin-left: ${props.marginLeft};`}
 ${props => props.marginRight && `margin-right: ${props.marginRight};`}
`;
const LoadingContainer = styled.div`
  align-self: center;
  margin: auto;
`;
const ButtonsContainer = styled(FlexContainer)`
  padding-top: 2em;
  button:first-child {
    margin-right: 15px;
  }
`;
const AbsoluteLoading = styled.div`
  background: white;
  position: absolute;
  align-self: center;
  margin: auto;
  opacity: 0.2;
  width: 100%;
  height: calc(100vh - var(--title-bar-offset, 0px) - 138px);
  overflow: none;
  svg {
    transform: translateX(35vw) translateY(50vh) translateY(-69px);
  }
`;
const WifiLabel = styled(H4_T)`
  padding-left: 0.5em;
  padding-top: 0.1em;
`;
const HeaderContainer = styled(FlexContainer).attrs({
  justifyContent: 'space-between',
  alignItems: 'center'
})``;
const PortHeader = styled(FlexContainer).attrs({
  direction: 'row',
  alignItems: 'center'
})`
  margin-top: 0.8em;
  &:after {
    display: inline-block;
    content: " ";
    width: 100%;
    height: 1px;
    border-bottom: 1px solid ${props => props.theme.colors.borderGray};
  }
`;
const PerChannelContainer = styled(FlexContainer).attrs({
  direction: 'row',
  alignItems: 'center'
})`
  border: 1px solid #d8dcd3;
  border-radius: 4px;
  padding: 0.5em 1em;
  margin-top: 0.8em;
`;
const SubTitle = styled(H4)`
  font-weight: 600;
  font-size: 10px;
  color: #333;
  padding-bottom: 0;
`;
const CenterText = styled.div`
  font-family: "Petasense Open Sans";
  font-weight: 600;
  text-align: center;
`;


class Transmitter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: {
        serial_number: props.sensor.serial_number,
        type: props.sensor.type,
        model: props.sensor.model,
        agent_url: props.sensor.agent_url,
        device_id: props.sensor.device_id,
        mac_address: props.sensor.mac_address,
        id: props.sensor.id,
        user: this.props.user
      },
      error: false,
      editMode: props.editMode,
      saveEnabled: false,
      openAssignSensorModal: false,
      selectedPortId: null,
      localLoading: false,
      ssid: '',
      passphrase: '',
      bssid: '',
      channel: null,
      ...getWifiScheduleState(null),
      errorMessages: {},
      showLastReportedModal: false,
      showLogAnalysisModal: false
    };
  }

  getSiteAccountId = () => resolveSiteAccountId({
    details: this.state.details,
    sensor: this.props.sensor,
    currentAccount: this.props.currentAccount,
  });

  getOrganisationId = () => resolveOrganisationId({
    details: this.state.details,
    sensor: this.props.sensor,
    currentAccount: this.props.currentAccount,
  });

  getTransferDeviceParams = () => {
    const deviceId = (this.state.details && this.state.details.id != null)
      ? this.state.details.id
      : (this.props.sensor && this.props.sensor.id);
    if (deviceId == null) return null;
    return { device_type: 'tx', device_id: deviceId };
  };

  // Sensors left on the ports block the transfer too: moving the Tx alone would
  // strand them in the old account, and the API rejects it.
  hasMachineAssociationForReassign = () => hasTransmitterMachineAssociation({
    sensor: this.props.sensor,
    details: this.state.details,
  }) || hasTransmitterAttachedSensors({ details: this.state.details });

  // A Tx has no machine link of its own -- it counts as on a machine only
  // because sensors on its ports are. So the remedy is the same either way:
  // unassign the sensors. The default "dissociate from machine" hint would
  // point at an action this panel does not have.
  getReassignDisabledHint = () => {
    const { t } = this.props;
    if (hasTransmitterAttachedSensors({ details: this.state.details })) {
      return t('sensors.reassignSite.disabledHintWiredSingle', {
        defaultValue: 'Sensors are still assigned to the ports of this transmitter. Unassign them before reassigning it to a different site.'
      });
    }
    return '';
  };

  handleSiteReassignSuccess = () => {
    // Refresh the list and close the panel; the device is no longer in it (else it hangs on a spinner).
    this.props.sensorsActions.getSensorsList();
    this.props.close();
  };

  componentDidMount() {
    const {
      details,
      sensor: { model, serial_number }
    } = this.props;
    let sensor = {};
    if (details[model]) {
      sensor = details[model].find(d => d.serial_number === serial_number);
    }
    if (sensor) {
      this.setState({
        details: _.cloneDeep(sensor)
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      details,
      sensor: { model, serial_number }
    } = this.props;
    const {
      details: prevDetails,
      sensor: { model: prevModel, serial_number: prevSerialNumber }
    } = prevProps;
    let sensor = {};
    let prevSensor = {};
    if (details[model]) {
      sensor = details[model].find(d => d.serial_number === serial_number);
    }
    if (prevDetails[prevModel]) {
      prevSensor = prevDetails[prevModel].find(
        d => d.serial_number === prevSerialNumber
      );
    }
    if (
      sensor &&
      (!_.isEqual(prevSensor, sensor) ||
        prevState.details.serial_number !== sensor.serial_number)
    ) {
      this.setState({
        details: _.cloneDeep(sensor)
      });
    }
    if (prevState.editMode !== this.props.editMode) {
      this.setState({
        editMode: this.props.editMode
      });
    }
    if (sensor && sensor.config_wifi_ssid !== (prevSensor && prevSensor.config_wifi_ssid)) {
      this.setState({ ssid: sensor.config_wifi_ssid });
    }
    if (sensor && sensor.config_wifi_passphrase !== (prevSensor && prevSensor.config_wifi_passphrase)) {
      this.setState({ passphrase: sensor.config_wifi_passphrase });
    }
    if (sensor && sensor.config_wifi_start_time !== (prevSensor && prevSensor.config_wifi_start_time)) {
      this.setState(getWifiScheduleState(sensor.config_wifi_start_time));
    }
    if (sensor && sensor.ap_bssid !== (prevSensor && prevSensor.ap_bssid)) {
      this.setState({ bssid: sensor.ap_bssid });
    }
    if (sensor && sensor.ap_channel !== (prevSensor && prevSensor.ap_channel)) {
      this.setState({ channel: sensor.ap_channel });
    }
    this.enableSave(sensor);
  }

  enableSave = (sensorDetails) => {
    const { details, errorMessages, saveEnabled, ssid, passphrase, bssid, channel } = this.state;
    if (!_.isEqual(details, sensorDetails) && _.isEmpty(errorMessages)) {
      if (saveEnabled !== true) this.setState({ saveEnabled: true });
    } else if (!_.isEmpty(ssid) && ssid !== _.get(
      this.props.details, [sensorDetails.model, '0', 'config_wifi_ssid']
    ) && _.isEmpty(errorMessages)) {
      if (saveEnabled !== true) this.setState({ saveEnabled: true });
    } else if (!_.isEmpty(passphrase) && passphrase !== _.get(
      this.props.details, [sensorDetails.model, '0', 'config_wifi_passphrase']
    ) && _.isEmpty(errorMessages)) {
      if (saveEnabled !== true) this.setState({ saveEnabled: true });
    } else if (isWifiConfigChanged(this.state, sensorDetails) && _.isEmpty(errorMessages)) {
      if (saveEnabled !== true) this.setState({ saveEnabled: true });
    } else if (!_.isEmpty(bssid) && bssid !== _.get(
      this.props.details, [sensorDetails.model, '0', 'ap_bssid']
    ) && _.isEmpty(errorMessages)
    ) {
      if (saveEnabled !== true) this.setState({ saveEnabled: true });
    } else if (!_.isEmpty(channel) && channel !== _.get(
      this.props.details, [sensorDetails.model, '0', 'ap_channel']
    ) && _.isEmpty(errorMessages)
    ) {
      if (saveEnabled !== true) this.setState({ saveEnabled: true });
    } else if (saveEnabled !== false) {
      this.setState({ saveEnabled: false });
    }
  };

  getPropsSensor = () => {
    const { details, sensor: { model, serial_number } } = this.props;
    if (!details[model]) return null;
    return details[model].find(d => d.serial_number === serial_number) || null;
  };

  validateInput = () => {
    const { ssid, passphrase, bssid, channel, wifi_schedule_date, wifi_schedule_time } = this.state;
    const errorMessages = {};
    if (ssid || passphrase) {
      if (!passphrase) errorMessages.passphrase_error = ErrorMessages.wifi_password_required;
      if (!ssid) errorMessages.ssid_error = ErrorMessages.wifi_ssid_required;
    }
    if (
      isWifiConfigChanged(this.state, this.getPropsSensor()) &&
      isWifiScheduleInPast(wifi_schedule_date, wifi_schedule_time)
    ) {
      errorMessages.wifi_schedule_error = ErrorMessages.wifi_schedule_in_past;
    }
    if (!_.isEmpty(bssid)) {
      if (!bssid.match(/^([A-Fa-f0-9]{12})$/)) {
        errorMessages.bssid_error = ErrorMessages.invalid_bssid;
      }
    }
    const channelInt = parseInt(channel, 10);
    if (_.isNumber(channelInt) && (channelInt < 1 || channelInt > 13)) {
      errorMessages.channel_error = ErrorMessages.invalid_channel;
    }
    this.setState({ errorMessages });
  };

  clearAPSettings = () => {
    this.setState({ bssid: '', channel: '' }, this.onSave);
  }

  onSave = () => {
    const { updateSensorDetails } = this.props.sensorsActions;
    const {
      details: { serial_number, model, reporting_interval },
      ssid,
      passphrase,
      wifi_schedule_date,
      wifi_schedule_time,
      bssid,
      channel
    } = this.state;
    const start_time = getEpochFromDateTime(
      wifi_schedule_date,
      wifi_schedule_time
    );
    const data = {
      [model]: {
        serial_number: [serial_number],
        reporting: {
          interval: reporting_interval
        },
        aggressive_measurement:
          reporting_interval <= AGGRESSIVE_INTERVAL_THRESHOLD,
        type: 'Transmitter'
      }
    };
    if (isWifiConfigChanged(this.state, this.getPropsSensor())) {
      data[model].wifi_config = {
        ssid,
        passphrase,
        start_time
      };
    }

    // Initialize wifi_ap_config
    data[model].wifi_ap_config = {};

    // Add bssid if it exists
    if (bssid && bssid.trim() !== '') {
      data[model].wifi_ap_config.bssid = bssid;
    }

    // Add channel if it exists and is valid
    if (channel !== null && channel !== undefined && channel !== '') {
      const channelInt = parseInt(channel, 10);
      if (!Number.isNaN(channelInt)) {
        data[model].wifi_ap_config.channel = channelInt;
      }
    }

    updateSensorDetails(data).then(
      res => res,
      error => toastr.error(parseErrorMessage(error))
    );
  };

  onCancel = () => {
    const {
      details,
      sensor: { model, serial_number }
    } = this.props;
    let sensor = {};
    if (details[model]) {
      sensor = details[model].find(d => d.serial_number === serial_number);
    }
    if (sensor && !_.isEqual(this.state.details, sensor)) {
      this.setState({
        details: _.cloneDeep(sensor)
      });
    }
  };

  handleInputClick = (e, data) => {
    const targetValue = e.target.value || data.value || '';
    const targetName = e.target.name || data.name;
    this.setState({ [targetName]: targetValue }, this.validateInput);
  };

  onChangeField = (e, { value }, name) => {
    this.setState(prevState => ({
      details: {
        ...prevState.details,
        [name]: value
      }
    }));
  };

  assignSensorToTx = (port_id, sensor_id) => {
    const { details } = this.state;
    this.setState({ localLoading: true });
    this.props.sensorsActions
      .assignSensorToTx(
        port_id,
        { sensor_id },
        details.model,
        details.serial_number
      )
      .then(
        () => {
          this.setState({ localLoading: false });
        },
        () => {
          this.setState({ localLoading: false });
        }
      );
  };

  unassignSensorFromTx = (sesnor_serial_number) => {
    const { details } = this.state;
    this.setState({ localLoading: true });
    const data = {
      serial_numbers: [sesnor_serial_number],
      tx_serial_no: details.serial_number
    };
    this.props.sensorsActions.unassignSensorFromTx(data).then(
      () => {
        this.setState({ localLoading: false });
      },
      () => {
        this.setState({ localLoading: false });
      }
    );
  };

  viewSensor = (serial_number, machine_id) => {
    const { getSensorDetails } = this.props.sensorsActions;
    const {
      details: { serial_number: txSerialNumber }
    } = this.state;
    const { appliedFilters } = this.props;
    delete appliedFilters.area_search_key;
    delete appliedFilters.machine_search_key;

    // Update VSX sensor serial numbers by removing specific suffixes
    let updatedSerialNumber = serial_number;
    if (serial_number.startsWith('VSX')) {
      updatedSerialNumber = serial_number
        .replace(/_accelerometer$/i, '')
        .replace(/_magnetometer$/i, '')
        .replace(/_temperature$/i, '');
    }

    if (this.props.machine_id) {
      if (this.props.machine_id === machine_id) {
        delete appliedFilters.machines;
        const filters = _.every(appliedFilters, value => _.isEmpty(value));
        const present = this.sensorPresentInTheList(updatedSerialNumber);
        if (!filters && !present) {
          this.setState({
            changeFilterModal: true,
            changeFilterSerialNumber: updatedSerialNumber
          });
          return;
        }
        getSensorDetails(updatedSerialNumber, true);
      } else if (machine_id) {
        history.push(`/machines/${this.props.machine_id}/devices`, {
          serial_number: txSerialNumber
        });
        history.push(`/machines/${machine_id}/devices`, { serial_number: updatedSerialNumber });
      } else {
        history.push('/devices', { serial_number: updatedSerialNumber });
      }
    } else {
      const filters = _.every(appliedFilters, value => _.isEmpty(value));
      const present = this.sensorPresentInTheList(updatedSerialNumber);
      if (!filters && !present) {
        this.setState({
          changeFilterModal: true,
          changeFilterSerialNumber: updatedSerialNumber
        });
        return;
      }
      getSensorDetails(updatedSerialNumber, true);
    }
  };

  clearAppliedFilters = () => {
    const { changeFilterSerialNumber } = this.state;
    if (!changeFilterSerialNumber) return;
    this.props.removeAppliedFilters(changeFilterSerialNumber);
  };

  sensorPresentInTheList = (serial_number) => {
    const { items } = this.props;
    return items.find(el => el.serial_number === serial_number);
  };

  openAssignSensorModal = (port_id) => {
    this.setState({
      openAssignSensorModal: true,
      selectedPortId: port_id
    });
  };

  handleLastReportedClick = () => {
    this.setState(prevState => ({
      lastReportedkey: prevState.lastReportedKey + 1
    }));
    this.setState({ showLastReportedModal: true });
  };

  handleLogAnalysisClick = () => {
    this.setState(prevState => ({
      logAnalysisKey: prevState.logAnalysisKey + 1
    }));
    this.setState({ showLogAnalysisModal: true });
  };


  allChannelsInUse = port =>
    port.sensors.reduce((acc, cur) => acc.concat(cur.channels), []).length === 3;

  filterReportingIntervals = () => {
    const { details } = this.state;
    const { metadata } = this.props;
    const anyTxSensorsInAggressiveMeasurement = _.some(details.ports, p =>
      _.some(p.sensors, 'aggressive_measurement')
    );
    if (anyTxSensorsInAggressiveMeasurement) {
      return _.filter(
        metadata[details.model].reporting.interval,
        o => o.value <= AGGRESSIVE_INTERVAL_THRESHOLD
      );
    }
    return _.filter(
      metadata[details.model].reporting.interval,
      o => o.value > AGGRESSIVE_INTERVAL_THRESHOLD
    );
  };

  refreshTxDetails = () => {
    const { details } = this.state;
    if (details && details.serial_number) {
      this.props.sensorsActions.getSensorDetails(details.serial_number);
    }
  };

  renderField = (type, label, options, value, disabled, name) => {
    const { editMode } = this.state;
    const { updating, t } = this.props;
    const translatedOptions = translateSensorSelectOptions(t, name, options);
    if (editMode) {
      return (
        <ResourceInputField
          type={type}
          label={label}
          name={name}
          key={name}
          options={translatedOptions}
          value={value}
          disabled={disabled || updating}
          onChange={(e, value) => this.onChangeField(e, value, name)}
          selectOnBlur={false}
        />
      );
    }
    let textValue = '';
    if (translatedOptions) {
      const element = translatedOptions.filter(option =>
        _.isEqual(option.value, value)
      )[0];
      if (element) textValue = element.text;
      else textValue = '--';
    }
    return (
      <Fragment>
        <ResourceItemLabel>{label}</ResourceItemLabel>
        <ResourceItem>{textValue}</ResourceItem>
      </Fragment>
    );
  };

  render() {
    const {
      details: {
        serial_number,
        type,
        model,
        battery_level,
        wifi_signal,
        wifi_rssi,
        wifi_ssid,
        poe,
        reporting_interval,
        ports,
        firmware_versions,
        agent_url,
        mac_address,
        device_id,
        last_report
      },
      saveEnabled,
      error,
      localLoading,
      ssid,
      passphrase,
      bssid,
      channel,
      errorMessages,
      wifi_schedule_date,
      wifi_schedule_time,
      showLastReportedModal,
      showLogAnalysisModal
    } = this.state;
    const {
      loading,
      detailsError,
      errorList,
      metadata,
      updating,
      user,
      primaryColor,
      t
    } = this.props;
    let aggressiveIconHoverText = t('sensors.detail.aggressiveHoverBattery');
    if (poe) {
      aggressiveIconHoverText = t('sensors.detail.aggressiveHoverPoe');
    }
    if (!loading && model && (!metadata || !metadata[model])) return t('sensors.errors.metadataModelMissing', { model });
    return (
      <Fragment>
        {(updating || localLoading) && (
          <AbsoluteLoading>
            <LoadingSvg />
          </AbsoluteLoading>
        )}
        {this.state.openAssignSensorModal && (
          <AssignSensorModal
            port_id={this.state.selectedPortId}
            assignSensorToTx={this.assignSensorToTx}
            close={() =>
              this.setState({
                openAssignSensorModal: false,
                selectedPortId: null
              })
            }
          />
        )}
        <Container>
          {loading && !error && !detailsError && (
            <LoadingContainer>
              <LoadingSvg />
            </LoadingContainer>
          )}
          {!loading && (error || detailsError) && (
            <div>
              {error || detailsError}{' '}
              <b>(serial numbers: {errorList.join(', ')})</b>
            </div>
          )}
          {!loading && !error && serial_number && model && (
            <Fragment>
              <HeaderContainer>
                <H1>{serial_number}</H1>
                <SvgContainer onClick={this.props.close}>
                  <CrossSvg width={25} height={25} />
                </SvgContainer>
              </HeaderContainer>
              <ResourceSection>{t('sensors.detail.transmitterInfo')}</ResourceSection>
              <BorderContainer>
                <Grid columns={3} doubling stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.type')}</ResourceItemLabel>
                        <ResourceItem>{type}</ResourceItem>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.model')}</ResourceItemLabel>
                        <ResourceItem>{model}</ResourceItem>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.firmware')}</ResourceItemLabel>
                        <ResourceItem>
                          {firmware_versions
                            ? firmware_versions.mcu || '--'
                            : '--'}
                        </ResourceItem>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.lastReportedAt')}</ResourceItemLabel>
                        <ResourceItem>{localTimeString(last_report)}</ResourceItem>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </BorderContainer>
              <Grid columns={1} doubling stackable>
                <SiteReassignSection
                  user={user}
                  currentAccount={this.props.currentAccount}
                  editMode={this.state.editMode}
                  getOrganisationSites={this.props.sensorsActions.getOrganisationSites}
                  transferDeviceToSite={this.props.sensorsActions.transferDeviceToSite}
                  getOrganisationId={this.getOrganisationId}
                  getSiteAccountId={this.getSiteAccountId}
                  getTransferDeviceParams={this.getTransferDeviceParams}
                  hasMachineAssociation={this.hasMachineAssociationForReassign}
                  getDisabledHint={this.getReassignDisabledHint}
                  onReassignSuccess={this.handleSiteReassignSuccess}
                  t={t}
                />
              </Grid>
              <ResourceSection>{t('sensors.detail.batteryWireless')}</ResourceSection>
              <BorderContainer>
                <Grid columns={3} doubling stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.batteryLevel')}</ResourceItemLabel>
                        <ResourceItem>
                          <FlexContainer>
                            {poe ? (
                              <PoeIcon />
                            ) : (
                              <BatteryIcon batteryLevel={battery_level} />
                            )}
                          </FlexContainer>
                        </ResourceItem>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.wifiSignal')}</ResourceItemLabel>
                        <ResourceItem>
                          <FlexContainer direction="row">
                            {_.isNull(wifi_signal) && (
                                <div
                                  title={
                                    wifi_rssi &&
                                    t('sensors.detail.lastWifiRssiTitle', { value: wifi_rssi })
                                  }
                                >
                                  <ResourceItem>
                                  {t('sensors.detail.na')}
                                  </ResourceItem>
                                </div>
                            )}
                            {!_.isNull(wifi_signal) && (
                              <WiFiSvg wifiLevel={wifi_signal} />
                            )}
                            {!_.isNull(wifi_signal) && wifi_rssi && (
                              <WifiLabel>
                                <ResourceItem>{wifi_rssi} dB</ResourceItem>
                              </WifiLabel>
                            )}
                          </FlexContainer>
                        </ResourceItem>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment>
                        <ResourceItemLabel>{t('sensors.detail.wifiSsid')}</ResourceItemLabel>
                        <FlexContainer direction="row">
                          {_.isNull(wifi_ssid) && (
                            <div>
                              <ResourceItem>{t('sensors.detail.na')}</ResourceItem>
                            </div>
                          )}
                          {wifi_ssid && (
                            <WifiLabel>
                              <ResourceItem>{wifi_ssid}</ResourceItem>
                            </WifiLabel>
                          )}
                        </FlexContainer>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                {this.props.editMode && (
                <Grid columns={4} doubling stackable>
                  <Grid.Row columns={1}>
                    <Grid.Column>
                      <Segment>
                        <RBAC
                          yes={(
                              <Accordion
                                title={t('sensors.detail.wifiSettings')}
                                color="grey"
                                fontsize="12px"
                                marginbottom="18px"
                              >
                              <WifiSetting
                                ssid={ssid}
                                passphrase={passphrase}
                                errorMessages={errorMessages}
                                wifi_schedule_date={wifi_schedule_date}
                                wifi_schedule_time={wifi_schedule_time}
                                preferredTimeOptions={this.preferredTimeOptions}
                                handleInputClick={this.handleInputClick}
                              />
                              </Accordion>
                         )}
                        />
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={1}>
                    <Grid.Column>
                      <Segment>
                        <RBAC
                          yes={(
                              <Accordion
                                title={t('sensors.detail.preferredAPSettings')}
                                color="grey"
                                fontsize="12px"
                                marginbottom="18px"
                              >
                                <Button
                                  text
                                  fontsize="12px"
                                  onClick={this.clearAPSettings}
                                  paddingLeft="0"
                                  paddingBottom="10px"
                                >
                                  {t('sensors.detail.clearAPSettings')}
                                </Button>
                                <PreferredAPSettings
                                  bssid={bssid}
                                  channel={channel}
                                  errorMessages={errorMessages}
                                  handleInputClick={this.handleInputClick}
                                />
                              </Accordion>
                         )}
                        />
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                )}
              </BorderContainer>
              <ResourceSection>{t('sensors.detail.reporting')}</ResourceSection>
              <BorderContainer>
                <Grid columns={3} doubling stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <Segment>
                        {this.renderField(
                          'select',
                          t('sensors.detail.interval'),
                          this.filterReportingIntervals(),
                          reporting_interval,
                          false,
                          'reporting_interval',
                          true
                        )}
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </BorderContainer>
              {(isPetasenseAdmin(user) || isPetasenseViewer(user) || isPartnerAdmin(user)) && (
                <>
                  <ResourceSection>{t('sensors.detail.advancedDeviceDetails')}</ResourceSection>
                  <BorderContainer>
                    <Grid columns={3} doubling stackable>
                      <Grid.Row>
                        <Grid.Column>
                          <Segment>
                            <ResourceItemLabel>{t('sensors.detail.deviceId')}</ResourceItemLabel>
                            <ResourceItem>{device_id}</ResourceItem>
                          </Segment>
                        </Grid.Column>
                        <Grid.Column>
                          <Segment>
                            <ResourceItemLabel>{t('sensors.detail.macAddress')}</ResourceItemLabel>
                            <ResourceItem>{mac_address}</ResourceItem>
                          </Segment>
                        </Grid.Column>
                        {agent_url && (
                          <Grid.Column>
                            <Segment>
                              <ResourceItemLabel>{t('sensors.detail.agent')}</ResourceItemLabel>
                              <ResourceItemLabel>{t('sensors.detail.impPage')}</ResourceItemLabel>
                              <ResourceItem>
                                <a
                                  href={getImpUrl(device_id)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: primaryColor,
                                    fontSize: '12px',
                                    fontWeight: 600,
                                    letterSpacing: '1.2px'
                                  }}
                                >
                                  {t('sensors.detail.url')}
                                </a>
                              </ResourceItem>
                            </Segment>
                          </Grid.Column>
                        )}
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column>
                          <Segment>
                            <ResourceItemLabel>{t('sensors.detail.logs')}</ResourceItemLabel>
                            <ResourceItem>
                              {' '}
                              <a
                                href={getDeviceGCPLogsUrl(serial_number)}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: primaryColor,
                                  fontSize: '12px',
                                  fontWeight: 600,
                                  letterSpacing: '1.2px'
                                }}
                              >
                                {t('sensors.detail.viewAction')}
                              </a>
                            </ResourceItem>
                          </Segment>
                        </Grid.Column>
                        <Grid.Column>
                          <Segment>
                            <ResourceItemLabel>{t('sensors.detail.analysis')}</ResourceItemLabel>
                            <ResourceItem>
                              <AnalysisButton
                                text
                                onClick={this.handleLogAnalysisClick}
                                fontsize="12px"
                                paddingBottom=""
                              >
                                {t('sensors.detail.viewAnalysis')}
                              </AnalysisButton>
                            </ResourceItem>
                          </Segment>
                        </Grid.Column>
                        <Grid.Column>
                          <Segment>
                            <ResourceItemLabel>
                              {t('sensors.detail.lastReportedInfo')}
                            </ResourceItemLabel>
                            <ResourceItem>
                              <AnalysisButton
                                text
                                onClick={this.handleLastReportedClick}
                                fontsize="12px"
                                paddingBottom=""
                              >
                                {t('sensors.detail.viewAction')}
                              </AnalysisButton>
                            </ResourceItem>
                          </Segment>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column>
                         <Segment>
                          <ResourceItemLabel>{t('sensors.detail.config')}</ResourceItemLabel>
                          <ResourceItem style={{ color: 'red' }}>
                                    <a
                                      href={getFullEndPointUrl(ENDPOINT.DEVICE_CONFIG(serial_number))}
                                      style={{
                                        color: primaryColor,
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        letterSpacing: '1.2px'
                                      }}
                                      target="blank"
                                    >
                                      {t('sensors.detail.viewAction')}
                                    </a>
                          </ResourceItem>
                         </Segment>
                        </Grid.Column>
                        <Grid.Column>
                         <Segment>
                          <ResourceItemLabel>{t('sensors.detail.configHistories')}</ResourceItemLabel>
                          <ResourceItem style={{ color: 'red' }}>
                                    <a
                                      href={getFullEndPointUrl(ENDPOINT.DEVICE_CONFIG_HISTORY(serial_number))}
                                      style={{
                                        color: primaryColor,
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        letterSpacing: '1.2px'
                                      }}
                                      target="blank"
                                    >
                                      {t('sensors.detail.viewAction')}
                                    </a>
                          </ResourceItem>
                         </Segment>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </BorderContainer>
                </>
              )}
              {showLastReportedModal && (
                <LastReportedModal
                  serialNumber={serial_number}
                  onCancel={() =>
                    this.setState({ showLastReportedModal: false })
                  }
                />
              )}
              {showLogAnalysisModal && (
                <DeviceParameterAnalysis
                  deviceId={this.state.details.id}
                  last_report={localTimeString(last_report)}
                  model={model}
                  serialNumber={serial_number}
                  onCancel={() =>
                    this.setState({ showLogAnalysisModal: false })
                  }
                  isTx
                />
              )}
              {/* {ports && _.isEmpty(ports[0].sensors) && <H3>No sensors associated to this port</H3>} */}
              {this.props.assignSensorVersionV2 && (
                <TxPorts
                  txs={[this.state.details]}
                  editMode={this.props.editMode}
                  viewSensor={this.viewSensor}
                  unassignSensor={this.unassignSensorFromTx}
                  metadata={this.props.metadata}
                  onUpdateSensorSettings={this.props.sensorsActions.updateSensorDetails}
                  onRefreshTxDetails={this.refreshTxDetails}
                  user={this.props.user}
                />
              )}
              {!this.props.assignSensorVersionV2 &&
                ports &&
                ports.map((port, index) => (
                  <>
                    <BorderContainer>
                      <ResourceSection>
                        <PortHeader key={`header-${index}`}>
                          <TxPortSvg
                            width={60}
                            height={30}
                            portNumber={port.port_position}
                          />
                          <ResourceItemLabel
                            grey
                            marginbottom="0"
                            paddingtop="0"
                          >
                            {t('sensors.detail.portLabel', { position: port.port_position })}
                          </ResourceItemLabel>
                        </PortHeader>
                      </ResourceSection>
                      {port.sensors.map((sensor, idx) => (
                        <Grid columns={3} doubling stackable>
                          <PerChannelContainer key={`port1-${idx}`}>
                            <PerChannelSvg channels={sensor.channels} />
                            <Grid.Row columns={3}>
                              <Grid.Column>
                                <ResourceItem noPadding marginRight="4em">
                                  {t('sensors.detail.channelLabel', { channels: sensor.channels.join() })}
                                </ResourceItem>
                              </Grid.Column>
                              <Grid.Column>
                                <ResourceItem
                                  noPadding
                                  marginRight="4em"
                                  hover={
                                    sensor.sensor_type && !this.props.editMode
                                  }
                                  onClick={
                                    sensor.sensor_type && !this.props.editMode
                                      ? () =>
                                        this.viewSensor(
                                          sensor.serial_number,
                                          sensor.machine_id
                                        )
                                      : () => {}
                                  }
                                >
                                  {sensor.sensor_type
                                    ? `${getSensorTypeDisplayName(this.props.t, this.props.i18n, sensor.sensor_type)} (${sensor.serial_number})`
                                    : '--'}
                                  {sensor.aggressive_measurement && (
                                    <span
                                      style={{
                                        float: 'right',
                                        paddingLeft: '5px'
                                      }}
                                      title={aggressiveIconHoverText}
                                    >
                                      <AggressiveReadingIcon />
                                    </span>
                                  )}
                                </ResourceItem>
                                <SubTitle>
                                  {sensor.machine ? t('sensors.detail.onMachinePrefix') : ''}
                                  {sensor.machine
                                    ? sensor.machine
                                    : t('sensors.detail.notAssociatedToMachine')}
                                </SubTitle>
                              </Grid.Column>
                              <Grid.Column>
                                {this.props.editMode && (
                                  <Button
                                    text
                                    color="red"
                                    marginLeft="auto"
                                    fontsize="12px"
                                    onClick={() =>
                                      this.unassignSensorFromTx(
                                        sensor.serial_number
                                      )
                                    }
                                  >
                                    {t('sensors.detail.unassign')}
                                  </Button>
                                )}
                              </Grid.Column>
                            </Grid.Row>
                          </PerChannelContainer>
                        </Grid>
                      ))}
                      {this.props.editMode && !this.allChannelsInUse(port) && (
                        <Button
                          text
                          marginTop="10px"
                          fontsize="12px"
                          onClick={() =>
                            this.openAssignSensorModal(port.port_id)
                          }
                        >
                          {t('sensors.detail.assignSensor')}
                        </Button>
                      )}
                    </BorderContainer>
                  </>
                ))}
              {this.state.editMode && (
                <ButtonsContainer>
                  <SaveButton disabled={!saveEnabled} onClick={this.onSave}>
                    {t('sensors.detail.save')}
                  </SaveButton>
                  <SaveButton
                    secondary="#3C3D3A"
                    disabled={!saveEnabled}
                    onClick={this.onCancel}
                  >
                    {t('sensors.detail.cancel')}
                  </SaveButton>
                </ButtonsContainer>
              )}
            </Fragment>
          )}
        </Container>
       {this.state.changeFilterModal && (
          <Modal
            width="40%"
            close={() => this.setState({ changeFilterModal: false, changeFilterSerialNumber: null })}
          >
            <CenterText>
              {t('sensors.detail.filterModalMessage')}
            </CenterText>
            <FlexContainer justifyContent="center">
              <ButtonsContainer>
                <Button width="70px" onClick={this.clearAppliedFilters}>{t('sensors.detail.ok')}</Button>
                <Button secondary="#3C3D3A" onClick={() => this.setState({ changeFilterModal: false, changeFilterSerialNumber: null })}>{t('sensors.detail.cancel')}</Button>
              </ButtonsContainer>
            </FlexContainer>
          </Modal>
       )}
      </Fragment>
    );
  }
}
const mapStateToProps = state => ({
  items: state.sensors.items.object,
  metadata: state.sensors.metadata.metadata,
  details: state.sensors.details.details,
  loading: state.sensors.details.loading,
  detailsError: state.sensors.details.error,
  updating: state.sensors.details.updating,
  errorList: state.sensors.details.errorList,
  user: state.user.user,
  primaryColor: state.companyReducer.partner.theme.primaryColor,
  currentAccount: state.currentAccount,
});
const mapDispatchToProps = dispatch => ({
  sensorsActions: bindActionCreators(sensorsActions, dispatch)
});
// Named apart from the default export so default importers do not trip import/no-named-as-default.
export { Transmitter as TransmitterBase };
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Transmitter));
